import errobj from 'errobj';
import { UNWANTED_VALUES } from '../constants';

/**
 * Key transformation mapping, will be used to format error objects by removing the second item, and using its value as a fallback to the first one.
 * @type {Array[]}
 */
const KEY_TRANSFORM = [
    [ 'file', 'fileName' ],
    [ 'line', 'lineNumber' ],
    [ 'column', 'columnNumber' ],
    [ 'function', 'functionName' ]
];

/**
 * Serialise error to object
 * @param  {Error} error
 * @param  {Object} details
 * @return {Object}
 */
export default function serialiseError(error, details = {}) {
    const struct = errobj(error, details);

    KEY_TRANSFORM.forEach(
        ([keep, remove]) => {
            struct[keep] = struct[keep] || struct[remove];
            delete struct[remove];
        }
    );

    return cleanNil(struct);
}

/**
 * Remove all items that have value of null or undefined
 * @param  {object} object
 * @return {object}
 */
function cleanNil(object) {
    Object
        .keys(object)
        .forEach((key) => {
            if (UNWANTED_VALUES.includes(object[key])) {
                delete object[key];
            }
        });

    return object;
}
